import { customLog } from 'helpers/customLog';

import { useEffect } from 'react';

import { useRefSection } from '@/hooks/useRefSection';
import { useScreenSize } from '@/hooks/useScreenSize';

export const useHashRouter = (
  headerRef: any,
  location: any,
  sectionRefs: any,
  contentData: any
) => {
  const { refScroll } = useRefSection();
  const { isSmallScreen, isMediumScreen } = useScreenSize();

  useEffect(() => {
    const { hash } = location;

    if (!hash) return;
    // If hash is empty or content is still loading, do not attempt to scroll
    if (!hash && !sectionRefs.current) return;

    const targetRef = sectionRefs?.current[hash.replace('#', '')]; // Get the ref for the target section
    customLog('sectionRef', sectionRefs, targetRef);
    // Check if the target ref exists and is not null
    const interval = setInterval(() => {
      if (targetRef && targetRef.current) {
        requestAnimationFrame(() => {
          refScroll(targetRef.current, headerRef, isSmallScreen, isMediumScreen);

          if (typeof window === 'undefined') return;

          // Strip the hash after navigation so the URL stays clean
          const [pathWithoutHash] = hash.split('#');
          const urlWithoutHash = pathWithoutHash || window.location.pathname;

          window.history.replaceState(null, '', urlWithoutHash);
        });
        clearInterval(interval); // Stop the interval after success
      }
    }, 100);

    return () => clearInterval(interval);
  }, [location, headerRef, sectionRefs, contentData]); // Dependencies

  return;
};
